// -----------------------------------------------------------------------------
// Library
// -----------------------------------------------------------------------------

import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

// -----------------------------------------------------------------------------
// Components
// -----------------------------------------------------------------------------
import { CategoriesCard } from "components/Categories/CategoriesCard";

import { EditWorkoutModal } from "components/Modals/EditWorkoutModal";
import { Tabs, Typography } from "antd";

import WorkoutsTable from "components/Workouts/WorkoutsTable";
import { useGetDomainGymQuery, useGetGymWorkoutsQuery } from "store/api/api";
import {
	updateSelectedMuxVideoUrl,
	updateSelectedWorkout,
	updateMembersWorkoutsSelectedCategories,
	updateMembersWorkoutsSelectedEquipment,
	updateMembersWorkoutsSelectedTrainers,
	updateMembersWorkoutsSelectedMusic,
	updateMembersWorkoutsSelectedDuration,
} from "store/slices";
import "./workoutStyles.scss";
import { workoutTypes } from "helpers/constants";
import { useParams } from "react-router";

// -----------------------------------------------------------------------------
// Styles and utils
// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------
const TabLabels = ({ children, active }) => (
	<Typography.Text style={{ color: active ? "#000" : "rgba(0,0,0,0.5)" }} className="tab-label" strong>
		{children}
	</Typography.Text>
);
const Workouts = () => {
	const dispatch = useDispatch();

	const [showEditWorkoutModal, setShowEditWorkoutModal] = useState(false);
	const [isEditingLive, setIsEditingLive] = useState(false);
	const { gym } = useParams();
	const domainGymResponse = useGetDomainGymQuery(gym);
	const domainGymId = domainGymResponse?.data?.id;
	const workoutsResponse = useGetGymWorkoutsQuery({ gym_id: domainGymId }, { skip: !domainGymId });
	const [selectedLiveStream, setSelectedLiveStream] = useState(null);
	const [activeTab, setActiveTab] = useState("all");

	const onEditSetVisible = (bool) => {
		setShowEditWorkoutModal(bool);

		if (!bool) {
			dispatch(updateSelectedWorkout({ workout: null }));
			dispatch(updateSelectedMuxVideoUrl({ url: null }));
		}
	};

	useEffect(() => {
		return () => {
			dispatch(updateMembersWorkoutsSelectedEquipment([]));
			dispatch(updateMembersWorkoutsSelectedTrainers([]));
			dispatch(updateMembersWorkoutsSelectedMusic([]));
			dispatch(updateMembersWorkoutsSelectedDuration([]));
			dispatch(updateMembersWorkoutsSelectedCategories([0]));
		};
	}, []);

	return (
		<div className="sb-creator-workouts">
			<div className="sb-creator-workouts__categories" data-id="sectionCategories">
				<CategoriesCard />
			</div>
			<div className="sb-creator-workouts__body">
				<Tabs
					onChange={setActiveTab}
					items={[
						{
							label: <TabLabels active={activeTab === workoutTypes.ON_DEMAND}>On Demand</TabLabels>,
							key: "live",
							children: (
								<WorkoutsTable
									setShowEditWorkoutModal={setShowEditWorkoutModal}
									setIsEditingLive={setIsEditingLive}
									setSelectedLiveStream={setSelectedLiveStream}
									showAll={false}
									workoutType={[workoutTypes.ON_DEMAND]}
								/>
							),
						},
						{
							label: <TabLabels active={activeTab === workoutTypes.SCHEDULED_ON_DEMAND}>Scheduled On Demand</TabLabels>,
							key: workoutTypes.SCHEDULED_ON_DEMAND,
							children: (
								<WorkoutsTable
									setShowEditWorkoutModal={setShowEditWorkoutModal}
									setIsEditingLive={setIsEditingLive}
									setSelectedLiveStream={setSelectedLiveStream}
									page="on-demand"
									workoutType={[workoutTypes.SCHEDULED_ON_DEMAND]}
									hideBulkStatusChange
								/>
							),
						},
					]}
				/>
			</div>

			<EditWorkoutModal
				open={showEditWorkoutModal}
				setOpen={onEditSetVisible}
				isEditingLive={isEditingLive}
				setIsEditingLive={setIsEditingLive}
				liveStream={selectedLiveStream}
				onClose={() => workoutsResponse?.refetch?.()}
			/>
		</div>
	);
};

export default Workouts;
